import { ModelInclude } from '../model-include'

interface StoreEntry<T> {
  include: ModelInclude
  requestData: T
}

export class ModelRequestStore<T> {
  private _store = new Map<string, Array<StoreEntry<T>>>()

  public getRequest(key: string, modelInclude: ModelInclude): T {
    return (this._getStoreEntry(key, modelInclude) || this._createStoreEntry()).requestData
  }

  public setRequest(key: string, modelInclude: ModelInclude, requestData: T) {
    const storeEntries = this._safeStoreGet(key)
    this._store.set(key, storeEntries)

    let tupleToSave = this._getStoreEntry(key, modelInclude)
    if (!tupleToSave) {
      tupleToSave = this._createStoreEntry(modelInclude)
      storeEntries.push(tupleToSave)
    }
    tupleToSave.requestData = requestData
  }

  public deleteRequest(key: string, modelInclude?: ModelInclude) {
    const storeEntries = this._safeStoreGet(key)

    this._deleteStrategy(modelInclude)(storeEntries, modelInclude)
  }

  public clear() {
    this._store.clear()
  }

  private _deleteStrategy(modelInclude: ModelInclude):
    (storeEntries: Array<StoreEntry<T>>, modelInclude: ModelInclude) => void {
    return ({
      undefined: ModelRequestStore._deleteAllStategy,
      object: ModelRequestStore._deleteEqualStategy
    })[typeof modelInclude]
  }

  private static _deleteAllStategy<T>(entries: Array<StoreEntry<T>>, _include: ModelInclude) {
    entries.splice(0, entries.length)
  }

  private static _deleteEqualStategy<T>(entries: Array<StoreEntry<T>>, include: ModelInclude) {
    for (let i = 0; i < entries.length; i++) {
      if (entries[i].include.equals(include)) {
        entries.splice(i, 1)
        break
      }
    }
  }

  private _getStoreEntry(key: string, modelInclude: ModelInclude): StoreEntry<T> {
    const storeEntries = this._safeStoreGet(key)
    return storeEntries.find((tuple: StoreEntry<T>) => tuple.include.includes(modelInclude))
  }

  private _safeStoreGet(key: string) {
    return this._store.get(key) || []
  }

  private _createStoreEntry(modelInclude?: ModelInclude): StoreEntry<T> {
    return { include: modelInclude, requestData: undefined }
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/model-repository/backends/model-request-store/model-request-store.ts